import { Box, Button, CardListItem, FileButton, Typography } from '@/components'
import { BaseProps } from '@/components/types'

function DirectRequestItem ( props: DirectRequestItemProps<PropertyContentData> ) {
    const {
        index, data, marginTop, marginBottom, isModifyAuth,
        onMove, onModify,
        ...rest
    } = props

    const { id: propertyId, telNo, investNm, sendStatus, createDate, advisorPicEmail, advisorPicNm, advisorPicTel } = data

    const listItemInfo = () => {
        if( isModifyAuth ) {
            return <>
                <span>{ `대주명: ${investNm || ''}` }</span>
                <br/>
                <span>{ `전화 번호: ${telNo || ''}` }</span>
                <br/>
                <span>{ `전송 여부: ${sendStatus || ''}` }</span>
                <br/>
            </>
        } else {
            return <>
                <span>{ `담당자: ${advisorPicNm || ''}` }</span>
                <br/>
                <span>{ `전화 번호: ${advisorPicTel || ''} ` }</span>
                <br/>
                <span>{ `이메일: ${advisorPicEmail || ''}` }</span>
                <br/>
            </>
        }
    }

    return (
        <CardListItem
            { ...rest }
            style={ { backgroundColor: '#f3f3f9' } }
            marginTop={ marginTop }
            marginBottom={ marginBottom }
            primaryText={ <span>{ `물건번호 : ${createDate}-` + propertyId }</span> }
            secondary={ listItemInfo() }
            leftContents={
                <Typography sx={ { width: 50 } }>
                    { index + 1 }
                </Typography>
            }
            rightContents={
                <Box className="flex h100p" sx={ { alignItems: 'center' } }>
                    { !isModifyAuth &&
                        <Button
                            className="w100p"
                            size="small"
                            sx={ { fontSize: '14px' } }
                            onClick={ () => { onMove( data ) } }
                        >
                            상세
                            <br/>
                            보기
                        </Button>
                    }
                    { isModifyAuth &&
                        <Button
                            className="w100p"
                            size="small"
                            sx={ { fontSize: '14px' } }
                            onClick={ () => { onModify( data ) } }
                        >
                            파일
                            <br/>
                            추가
                        </Button>
                    }
                </Box>
            }
        />
    )
}

export default DirectRequestItem

export interface DirectRequestItemProps<TData = any> extends BaseProps {
    index: number,
    data: TData,
    marginTop?: string | number
    marginBottom?: string | number
    isModifyAuth?: boolean
    onMove?: ( data: TData ) => void
    onModify?: ( data: TData ) => void
}

export type PropertyContentData = {
    id: number
    userId: number
    createDate: string
    investId: number
    investNm: string
    telNo: string
    sendStatus: string
    advisorPicEmail: string
    advisorPicNm: string
    advisorPicTel: string
}